/**
 * Shared motion tokens for the Agents shell.
 * Keeps easing and durations consistent across welcome state, thinking
 * indicator, mode transitions and journey card hover effects.
 */

export const AGENT_EASING = {
  outExpo: [0.16, 1, 0.3, 1] as [number, number, number, number],
  inOutQuart: [0.76, 0, 0.24, 1] as [number, number, number, number],
};

export const AGENT_DURATIONS = {
  hover: 0.2,
  fast: 0.24,
  base: 0.32,
  slow: 0.36,
};

export const fadeInUp = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
  transition: { duration: AGENT_DURATIONS.base, ease: AGENT_EASING.outExpo },
};

export const crossfadeBlur = {
  initial: { opacity: 0, y: 4, filter: 'blur(2px)' },
  animate: { opacity: 1, y: 0, filter: 'blur(0px)' },
  exit: { opacity: 0, y: -4, filter: 'blur(2px)' },
  transition: { duration: AGENT_DURATIONS.base, ease: AGENT_EASING.outExpo },
};

export const shellTransition = {
  duration: AGENT_DURATIONS.slow,
  ease: AGENT_EASING.outExpo,
};
